"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _Section = _interopRequireDefault(require("../../../components/Section"));

require("../styles/_colors-section.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var untitledFilter = function untitledFilter(_ref) {
  var name = _ref.name;
  return name !== 'Untitled';
};

var isEmptyColorsList = function isEmptyColorsList(colors) {
  return !colors || (0, _lodash.default)(colors.filter(untitledFilter));
};

function Colors(_ref2) {
  var colorPalettesOverview = _ref2.colorPalettesOverview,
      colorPalettes = _ref2.colorPalettes,
      gotoId = _ref2.gotoId,
      setRef = _ref2.setRef;
  return _react.default.createElement(_Section.default, {
    className: "colors-section",
    gotoId: gotoId,
    setRef: setRef,
    icon: "colour",
    title: "Color Palette",
    description: colorPalettesOverview,
    emptyText: "Your company has not added any colors yet"
  }, (0, _lodash.default)(colorPalettes) ? null : colorPalettes.map(function (_ref3) {
    var subBrandGroupId = _ref3.subBrandGroupId,
        name = _ref3.name,
        colors = _ref3.colors;
    return isEmptyColorsList(colors) ? null : _react.default.createElement(_react.Fragment, {
      key: subBrandGroupId
    }, _react.default.createElement("h2", null, name), _react.default.createElement("div", {
      className: "colors-section__container container"
    }, colors.map(function (_ref4) {
      var subBrandColorId = _ref4.subBrandColorId,
          colorName = _ref4.name,
          hexCode = _ref4.hexCode;
      return _react.default.createElement("div", {
        className: "colors-section__container__color-wrapper",
        key: subBrandColorId
      }, _react.default.createElement("div", {
        className: "colors-section__container__color-wrapper__color-panel",
        style: {
          backgroundColor: "#".concat(hexCode)
        }
      }), _react.default.createElement("h3", {
        className: "colors-section__container__color-wrapper__hex"
      }, "#".concat(hexCode)), _react.default.createElement("p", {
        className: "colors-section__container__color-wrapper__label"
      }, colorName));
    })));
  }).filter(Boolean));
}

var _default = (0, _react.memo)(Colors);

exports.default = _default;